import { render } from "./PagesComponent.vue?vue&type=template&id=e0d994cc&scoped=true"
import script from "./PagesComponent.vue?vue&type=script&lang=js"
export * from "./PagesComponent.vue?vue&type=script&lang=js"

import "./PagesComponent.vue?vue&type=style&index=0&id=e0d994cc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0d994cc"]])

export default __exports__